/* VWC V5.21 homepage build. Loaded with defer from layout/theme.liquid.
   Feature code registers an init function with window.VWC.register; inits run once the DOM is ready.
   Keep total size small (guide 1.6: under about 10KB), no jQuery, listeners after DOMContentLoaded.
   Slice 6 fix to the slice 1 skeleton: deferred scripts run while readyState is 'interactive', so the
   skeleton used to run its (empty) init list before any later code could register. register() now
   runs a function immediately when the DOM is already ready. */
(function () {
  'use strict';
  var inits = [];
  var ready = false;
  function safe(fn) {
    try { fn(); } catch (e) { if (window.console) console.error('VWC init failed', e); }
  }
  window.VWC = window.VWC || {};
  window.VWC.register = function (fn) {
    if (typeof fn !== 'function') return;
    if (ready) safe(fn); else inits.push(fn);
  };
  function run() {
    ready = true;
    for (var i = 0; i < inits.length; i += 1) safe(inits[i]);
    inits = [];
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();

/* Slice 6: campaign hero rotation. Dots jump, the pause button toggles, rotation stops on
   hover or keyboard focus and never starts for prefers-reduced-motion. */
window.VWC.register(function () {
  var roots = document.querySelectorAll('[data-vwc-hero]');
  Array.prototype.forEach.call(roots, function (root) {
    var slides = root.querySelectorAll('.vwc-slide');
    var dots = root.querySelectorAll('.vwc-slider-dot');
    var pauseBtn = root.querySelector('.vwc-slider-pause');
    if (slides.length < 2) return;
    var current = 0;
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var paused = reduced;
    var held = false;
    var seconds = parseInt(root.getAttribute('data-interval'), 10) || 7;
    function show(n) {
      var next = (n + slides.length) % slides.length;
      if (next === current) return;
      slides[current].classList.remove('is-active');
      slides[current].setAttribute('aria-hidden', 'true');
      if (dots[current]) { dots[current].classList.remove('is-active'); dots[current].removeAttribute('aria-current'); }
      current = next;
      slides[current].classList.add('is-active');
      slides[current].setAttribute('aria-hidden', 'false');
      if (dots[current]) { dots[current].classList.add('is-active'); dots[current].setAttribute('aria-current', 'true'); }
    }
    function setPaused(p) {
      paused = p;
      if (pauseBtn) {
        pauseBtn.setAttribute('aria-pressed', p ? 'true' : 'false');
        pauseBtn.setAttribute('aria-label', p ? 'Play slide rotation' : 'Pause slide rotation');
        var icon = pauseBtn.querySelector('span');
        if (icon) icon.textContent = p ? '\u25B6' : 'II';
      }
    }
    setPaused(paused);
    Array.prototype.forEach.call(dots, function (dot, k) {
      dot.addEventListener('click', function () { show(k); });
    });
    if (pauseBtn) pauseBtn.addEventListener('click', function () { setPaused(!paused); });
    // V5.22 A8: swipe left/right on touch screens (vertical scrolling untouched)
    var sx = null, sy = null;
    root.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) { sx = null; return; }
      sx = e.touches[0].clientX; sy = e.touches[0].clientY; held = true;
    }, { passive: true });
    root.addEventListener('touchend', function (e) {
      held = false;
      if (sx === null) return;
      var t = e.changedTouches[0]; var dx = t.clientX - sx; var dy = t.clientY - sy; sx = null;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.3) show(current + (dx < 0 ? 1 : -1));
    }, { passive: true });
    root.addEventListener('mouseenter', function () { held = true; });
    root.addEventListener('mouseleave', function () { held = false; });
    root.addEventListener('focusin', function () { held = true; });
    root.addEventListener('focusout', function () { held = false; });
    window.setInterval(function () {
      if (!paused && !held && !document.hidden) show(current + 1);
    }, seconds * 1000);
  });
});

/* V5.22 A8 finder heading tap (20 Oct 2026): on phones, tapping the finder's heading area opens or closes it (fields and links unaffected) */
document.addEventListener('click', function (e) {
  if (!window.matchMedia || !window.matchMedia('(max-width: 820px)').matches) return;
  var t = e.target;
  if (!t || !t.closest || !t.closest('#vwc-vehicle-finder .vwc-finder__title')) return;
  if (t.closest('a, button, select, input, label')) return;
  var b = document.querySelector('#vwc-vehicle-finder [data-vwc-finder-toggle]');
  if (b) b.click();
});

/* V5.22 A11 (20 Oct 2026): footer link groups are <details data-vwc-fold>. Closed by default (phones); opened at
   desktop widths so the columns show as before; a resize across the breakpoint re-syncs. */
(function () {
  var mq = window.matchMedia('(min-width: 821px)');
  function sync() { document.querySelectorAll('[data-vwc-fold]').forEach(function (d) { d.open = mq.matches; }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync); else sync();
  if (mq.addEventListener) mq.addEventListener('change', sync); else if (mq.addListener) mq.addListener(sync);
})();

/* V5.22 A13 (21 Oct 2026): paged homepage product rows. The page count follows the layout (4 per page on phones,
   8 on desktop), so the bars are rebuilt when the width crosses the breakpoint. */
(function () {
  function init(root) {
    if (root.dataset.vwcPagesReady) return; root.dataset.vwcPagesReady = '1';
    var track = root.querySelector('.vwc-pages__track');
    var groups = Array.prototype.slice.call(root.querySelectorAll('.vwc-pages__page'));
    var nav = root.querySelector('.vwc-pages__nav'); var box = root.querySelector('.vwc-pages__dots');
    var prev = root.querySelector('[data-vwc-prev]'); var next = root.querySelector('[data-vwc-next]');
    if (!track || !nav || !box) return;
    var stops = []; var dots = [];
    function measure() {
      var base = groups[0].offsetLeft; var seen = {};
      stops = [];
      groups.forEach(function (g) { var x = g.offsetLeft - base; var k = Math.round(x); if (!seen[k]) { seen[k] = 1; stops.push(x); } });
      if (stops.length !== dots.length) {
        box.innerHTML = ''; dots = [];
        stops.forEach(function (x, i) {
          var b = document.createElement('button'); b.type = 'button'; b.className = 'vwc-pages__dot';
          b.setAttribute('aria-label', 'Show page ' + (i + 1) + ' of ' + stops.length);
          b.addEventListener('click', function () { go(i); }); box.appendChild(b); dots.push(b);
        });
      }
      nav.hidden = stops.length < 2; sync();
    }
    function cur() { var x = track.scrollLeft, best = 0; stops.forEach(function (s, i) { if (Math.abs(s - x) < Math.abs(stops[best] - x)) best = i; }); return best; }
    function go(i) { i = Math.max(0, Math.min(stops.length - 1, i)); track.scrollTo({ left: stops[i], behavior: 'smooth' }); }
    function sync() {
      var c = cur();
      dots.forEach(function (d, i) { d.setAttribute('aria-current', i === c ? 'true' : 'false'); });
      if (prev) prev.disabled = c === 0; if (next) next.disabled = c >= stops.length - 1;
    }
    if (prev) prev.addEventListener('click', function () { go(cur() - 1); });
    if (next) next.addEventListener('click', function () { go(cur() + 1); });
    var t; track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(sync, 60); }, { passive: true });
    var r; window.addEventListener('resize', function () { clearTimeout(r); r = setTimeout(measure, 120); });
    measure();
  }
  function all() { document.querySelectorAll('[data-vwc-pages]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();
/* V5.22 search cover (26 Oct 2026): on phones and tablets the open search bar covers the whole header.
   Measures the header bottom when the search icon is tapped; without it the bar keeps its old height. */
document.addEventListener('click', function (e) {
  var s = e.target && e.target.closest && e.target.closest('details-modal.header__search summary');
  if (!s) return;
  var h = document.querySelector('.section-header');
  if (h) document.documentElement.style.setProperty('--vwc-search-cover', Math.max(0, Math.ceil(h.getBoundingClientRect().bottom)) + 'px');
}, true);
/* Contact forms 30 Oct 2026: the Powerful Form Builder upload box says "Add photos" (hint line unchanged). After a
   send the success box (which replaces the form, see vwc-v513.css) says what was sent, is scrolled to the middle of
   the screen instead of the app's jump to the form top, and offers "Send another message" to bring the form back.
   Wording is keyed by form id: 170247 VWC Contact Form, 170248 VWC Product Question. */
(function () {
  var COPY = {
    '170247': { title: 'Thanks, your message has been sent', text: 'We’ll reply to the email address you gave us.', again: 'Send another message' },
    '170248': { title: 'Thanks, your question has been sent', text: 'We’ll email you about {product}.', again: 'Ask another question' }
  };
  function relabel() {
    document.querySelectorAll('.globo-formbuilder .gfb__dropzone--placeholder--title').forEach(function (t) {
      if (t.textContent.trim() === 'Choose file or drag here') t.textContent = 'Add photos';
    });
  }
  function fill(form, msg) {
    var app = form.closest('.globo-form-app');
    var copy = COPY[(app && app.getAttribute('data-id')) || form.getAttribute('data-id')];
    if (!copy) return;
    var h = document.querySelector('.product__title h1');
    var product = h ? h.textContent.trim().split(/\s[–—-]\s/)[0] : 'this product'; /* name only, not the " – keywords" tail */
    var title = msg.querySelector('.gfb__content-title');
    var content = msg.querySelector('.content');
    if (title) title.textContent = copy.title;
    if (content) { content.textContent = ''; var p = document.createElement('p'); p.textContent = copy.text.replace('{product}', product); content.appendChild(p); }
    if (!msg.querySelector('.vwc-gfb-again')) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'vwc-gfb-again'; b.textContent = copy.again;
      b.addEventListener('click', function () {
        msg.style.display = 'none';
        var first = form.querySelector('.panels input:not([type=hidden]):not([type=file]), .panels textarea');
        if (first) first.focus();
      });
      msg.appendChild(b);
    }
  }
  window.VWC.register(relabel);
  document.addEventListener('globo.formbuilder.form.loaded', relabel);
  document.addEventListener('globo.formbuilder.form.submitted', function (e) {
    var form = e.detail && e.detail.form;
    var msg = form && form.querySelector('.message.success');
    if (!msg) return;
    fill(form, msg);
    setTimeout(function () {
      fill(form, msg);
      (msg.offsetParent ? msg : form).scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 600);
  });
})();
/* Product page 30 Oct 2026: a link to #<anchor> of a VWC collapsible row (the "Ask us" link under Add to Cart)
   opens the row and scrolls it to the top of the screen, below the sticky header. Also runs for a page opened
   with that hash in the URL. */
(function () {
  function rowFor(hash) {
    if (!hash || hash.length < 2) return null;
    var el = document.getElementById(decodeURIComponent(hash.slice(1)));
    return el && el.matches('details.vwc-collapse') ? el : null;
  }
  function openRow(row, smooth) {
    row.open = true;
    /* Leave room for the sticky header when it will be showing: always for 'always' / 'reduce-logo-size';
       for 'on-scroll-up' only when scrolling up, since it slides away on the way down (by --header-height,
       which on desktop is shorter than the header with the menu bar, so that sliver stays and is allowed for) */
    var sh = document.querySelector('sticky-header');
    var type = sh ? sh.getAttribute('data-sticky-type') : 'none';
    var y = row.getBoundingClientRect().top;
    var full = sh ? sh.getBoundingClientRect().height : 0;
    var shows = type === 'always' || type === 'reduce-logo-size' || (type === 'on-scroll-up' && y < 0);
    var slides = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || full;
    var offset = shows ? full : type === 'on-scroll-up' ? Math.max(0, full - slides) : 0;
    var top = y + window.pageYOffset - offset - 12;
    window.scrollTo({ top: Math.max(0, top), behavior: smooth ? 'smooth' : 'auto' });
    var s = row.querySelector('summary');
    if (s) s.focus({ preventScroll: true });
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href^="#"]');
    var row = a && rowFor(a.getAttribute('href'));
    if (!row) return;
    e.preventDefault();
    if (history.replaceState) history.replaceState(null, '', a.getAttribute('href'));
    openRow(row, true);
  });
  window.VWC.register(function () {
    var row = rowFor(location.hash);
    if (row) setTimeout(function () { openRow(row, false); }, 300);
  });
})();
/* reCAPTCHA notice 30 Oct 2026: Powerful Form Builder forms with reCAPTCHA (v3) switched on get Google's required
   notice under the submit button, so the floating badge can be hidden (it covered the full-width button on phones).
   The badge is hidden in vwc-v513.css only on pages that show this notice. */
(function () {
  function note() {
    document.querySelectorAll('.globo-formbuilder .globo-form-app').forEach(function (app) {
      var forms = window.Globo && Globo.FormBuilder && Globo.FormBuilder.forms;
      var cfg = forms && forms[app.getAttribute('data-id')];
      var footer = app.querySelector('.gfb__footer');
      if (!cfg || !cfg.reCaptcha || !cfg.reCaptcha.enable || !footer || app.querySelector('.vwc-recaptcha-note')) return;
      var p = document.createElement('p');
      p.className = 'vwc-recaptcha-note';
      p.innerHTML = 'This site is protected by reCAPTCHA and the Google <a href="https://policies.google.com/privacy" target="_blank" rel="noopener">Privacy Policy</a> and <a href="https://policies.google.com/terms" target="_blank" rel="noopener">Terms of Service</a> apply.';
      footer.insertAdjacentElement('afterend', p);
    });
  }
  window.VWC.register(note);
  document.addEventListener('globo.formbuilder.form.loaded', note);
})();
/* Phone fields 30 Oct 2026: Powerful Form Builder phone inputs get the number keypad, and Australian numbers are
   tidied to the 0-prefixed local form when the customer leaves the field or sends. iPhone autofill can fill
   "+61421795723" as "421795723" (no 0), which is what arrived in the enquiry emails. Only clear AU patterns are
   changed: +61/61 followed by 9 digits, or 9 digits starting 2, 3, 4, 7 or 8; anything else is left as typed. */
(function () {
  var SEL = '.globo-formbuilder input[name^="phone"]';
  function tidy(v) {
    var d = String(v || '').replace(/[\s().-]/g, '');
    if (/^\+?61[2-478]\d{8}$/.test(d)) return '0' + d.replace(/^\+?61/, '');
    if (/^[2-478]\d{8}$/.test(d)) return '0' + d;
    return v;
  }
  function fix(input) {
    var t = tidy(input.value);
    if (t !== input.value) { input.value = t; input.dispatchEvent(new Event('input', { bubbles: true })); }
  }
  function keypad() {
    document.querySelectorAll(SEL).forEach(function (i) { i.setAttribute('inputmode', 'tel'); });
  }
  document.addEventListener('change', function (e) { if (e.target.matches && e.target.matches(SEL)) fix(e.target); }, true);
  document.addEventListener('focusout', function (e) { if (e.target.matches && e.target.matches(SEL)) fix(e.target); }, true);
  document.addEventListener('submit', function (e) {
    if (e.target.closest && e.target.closest('.globo-formbuilder')) e.target.querySelectorAll('input[name^="phone"]').forEach(fix);
  }, true);
  window.VWC.register(keypad);
  document.addEventListener('globo.formbuilder.form.loaded', keypad);
})();
